export default "/images/vendor/flag-icons/flags/1x1/cv.svg?c4df14eee0b28bca07a3f28bd7efc7d8";